<template>
    <auth-layout>
        <loading-block v-if="loading" />
        <div v-else>
            <header-page :title="'#' + ticket.no" :subject="ticket.title" />
            <loading-block v-if="loadingChat" />
            <div class="mt-5" v-else>
                <div v-for="item in messages.data">
                    <ticket-message :item="item" />
                </div>
                <div class="d-flex mt-5">
                    <div class="mx-auto">
                        <pagination :data="messages" @pagination-change-page="getMessage"></pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="send-message-wrap" v-if="ticket.status">
            <button class="btn btn-primary" @click="openModal">Balas</button>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="sendModal" tabindex="-1" role="dialog" aria-labelledby="sendModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="sendModalLabel">Kirim Balasan</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <loading-block v-if="sendLoading" />
                        <div v-else>
                            <div class="form-group">
                                <label for="message">Pesan</label>
                                <textarea class="form-control" id="message" rows="3" v-model="form.message" v-bind:class="errors.hasOwnProperty('message') ? 'is-invalid' : ''"></textarea>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('message')">
                                    {{ errors['message'][0] }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="attachments">File Pendukung (jpg / pdf)</label>
                                <input type="file" class="form-control-file" id="attachments" @change="getAttachments" multiple v-bind:class="errors.hasOwnProperty('attachments') ? 'is-invalid' : ''">
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('attachments')">
                                    {{ errors['attachments'][0] }}
                                </div>
                                <small id="emailHelp" class="form-text text-muted" v-else>Maximal size file 2MB.</small>
                            </div>
                            <div class="recaptcha-wrap" v-bind:class="errors.hasOwnProperty('recaptcha') ? 'error' : ''">
                                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                                <span>Wajib diisi</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                        <button type="button" class="btn btn-primary" @click="sendMessage">Kirim</button>
                    </div>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import TicketMessage from "../../../mobile/components/Card/TicketMessage";
import {setAttachments, DataURIToBlob} from "../../UploadHandler";

export default {
    name: "Show",
    components: {
        'ticket-message': TicketMessage
    },
    data() {
        return {
            ticket: {},
            form: {
                message: '',
                attachments: [],
                recaptcha: ''
            },
            errors: [],
            messages: {},
            loading: true,
            loadingChat: true,
            sendLoading: false
        }
    },
    mounted() {
        this.getData();
        this.getMessage();
    },
    methods: {
        async getData() {
            const token = this.$cookies.get('token');
            await axios.get(`/api/ticket/${this.$route.params.id}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.ticket = response.data;
                    this.loading = false;
                })
                .catch((error) => {

                });
        },
        async getMessage(page = 1) {
            const token = this.$cookies.get('token');
            this.loadingChat = true;
            await axios.get(`/api/ticket/message/${this.$route.params.id}?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.messages = response.data;
                    this.loadingChat = false;
                    window.scrollTo(0,0);
                })
                .catch((error) => {

                });
        },
        openModal() {
            $('#sendModal').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        sendMessage() {
            const token = this.$cookies.get('token');
            this.errors = [];
            let formData = new FormData();
            this.form.attachments.forEach(file => {
                const item = DataURIToBlob(file)
                formData.append('attachments[]', item);
            });
            formData.append('message', this.form.message);
            formData.append('recaptcha', this.form.recaptcha);
            this.sendLoading = true;
            axios.post(`/api/ticket/message/${this.$route.params.id}`, formData, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.sendLoading = false;
                    this.getMessage();
                    $('#sendModal').modal('hide');
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                    this.sendLoading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        getAttachments(e) {
            var files = e.target.files;
            const response = setAttachments(files);
            if(response === false) {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "File bukan berupa gambar",
                    type: 'warn'
                });
            } else {
                this.form.attachments = response;
            }
        }
    }
}
</script>

<style scoped>
.send-message-wrap {
    position: fixed;
    right: 15px;
    bottom: 15px;
}
</style>
